import Furniture from './Furniture';
// import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class Tent extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.version = data.version || 1;
    this.back.frameName = 'back_' + this.version;
    this.front.frameName = 'front_' + this.version;

    this.empty = true;
    this.addButton();
  }

  createAsset() {
    this.back = this.game.make.image(
      this.data.back_offset.x,
      this.data.back_offset.y,
      this.data.key,
      'back_1'
    );
    this.back.x -= this.back.width * 0.5;
    this.back.y -= this.back.height;
    this.container = this.game.make.group();
    this.front = this.game.make.image(0, 0, this.data.key, 'front_1');
    this.front.anchor.set(0.5, 1);

    this.addChild(this.back);
    this.addChild(this.container);
    this.addChild(this.front);
  }

  addButton() {
    this.front.inputEnabled = true;
    this.front.events.onInputDown.add(this.handleInputDown, this);
    this.front.input.pixelPerfectClick = true;
    this.front.input.pixelPerfectOver = true;
    this.front.input.useHandCursor = true;

    this.back.inputEnabled = true;
    this.back.input.pixelPerfectClick = true;
    this.back.input.pixelPerfectOver = true;
    this.back.input.useHandCursor = false;
  }

  setLight(power) {
    this.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.back.tint = this.tintColor;
    this.front.tint = this.tintColor;
  }

  //
  handleInputDown() {
    // change tent skin
    this.version++;
    if (this.version > 3) {
      this.version = 1;
    }

    this.back.frameName = 'back_' + this.version;
    this.front.frameName = 'front_' + this.version;

    //
    this.game.sounds.playSFX('item_tentfabric', { spriteID: 'sfx' });

    //
    this.onChange.dispatch();
  }

  canAddCharacter(x, y) {
    x = x - this.x - this.back.x;
    y = y - this.y - this.back.y;
    if (
      this.empty &&
      x > 0 &&
      x < this.back.width &&
      y > 0 &&
      y < this.back.height &&
      this.back.input.checkPixel(x, y)
    ) {
      return true;
    }
    return false;
  }

  addCharacter(character) {
    this.empty = false;
    character.putIntoTent(this, this.data.sleep);
    this.container.addChild(character);

    this.game.sounds.playSFX('item_sleeping', { spriteID: 'sfx' });
  }

  animateGrowUp() {
    super.animateGrowUp();

    this.game.sounds.playSFX('item_tentup', { spriteID: 'sfx' });
  }

  serialize() {
    const data = super.serialize();
    data.version = this.version;
    return data;
  }
}
